import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-report-query",
  "use": "icon-report-query-usage",
  "viewBox": "0 0 1030 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1030 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-report-query\"><path d=\"M455.849833 0C204.062741 0 0 204.062741 0 455.849833s204.062741 455.849833 455.849833 455.849833 455.849833-204.062741 455.849833-455.849833S707.636925 0 455.849833 0z m0 826.124968C251.655438 826.124968 85.574698 660.044227 85.574698 455.849833S251.655438 85.574698 455.849833 85.574698s370.275135 166.080741 370.275135 370.275135-166.080741 370.275135-370.275135 370.275135zM1017.680638 950.932373l-142.712266-142.712265c-16.719979-16.719979-43.774749-16.719979-60.494728 0s-16.719979 43.774749 0 60.494729l142.712265 142.712265c8.35999 8.35999 19.28722 12.507071 30.280278 12.507071s21.920288-4.147082 30.280277-12.507071a42.747853 42.747853 0 0 0 0-60.494729z\" p-id=\"9933\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/report-query.svg
// module id = cFkH
// module chunks = 36